import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get,  post} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    success:'',
    info: [],
    infoLoading: false,
    infoError : '',
}

export const fetchContact = createAsyncThunk("fetchContact", (params, {dispatch}) => {
    return get(params);
});

export const postForm = createAsyncThunk("careerForm", (params) => {
    return post(params);
});

export const fetchInfo = createAsyncThunk("fetchInfo", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'contact',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchContact.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchContact.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchContact.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(postForm.pending, (state) => {
            state.loading = true;
            state.success = [];
            state.error = "";
        });
        builder.addCase(postForm.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.error = "";

        });
        builder.addCase(postForm.rejected, (state, action) => {
            state.loading = false;
            state.success = '';
            state.error = action.error;

        })
        builder.addCase(fetchInfo.pending, (state) => {
            state.infoLoading = true
            state.info = []
            state.infoError = ''
        })
        builder.addCase(fetchInfo.fulfilled, (state, action) => {
            state.infoLoading = false
            state.info = action.payload
            state.infoError = ''

        })
        builder.addCase(fetchInfo.rejected, (state, action) => {
            state.infoLoading = false
            state.info = []
            state.infoError = action.error
        });
    }
})


export default postSlice.reducer
